import { useCallback } from 'react';

import * as Types from '../types';

export const useLaunchGameByCasino = () => {
    return useCallback((data: Types.ILaunchGameOptions): void => {
        if (window.parent) {
            // in case game is launched from NGM CP or GDK
            window.parent.postMessage({
                _type: 'com.pt.casino.client.integration.overlay.OpenGameNotification',
                gameCode: data.code
            }, document.referrer || document.location.href);
        }
    }, []);
};
